import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  UPDATE_affiliateGet,
  GET_USER_ADDON,
  GET_USER_PLAN_LIMITS,
} from "../services/constants";
import { GET_AFF_CONVERSION } from "../Affiliate/utils/Api";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ZustandStore } from "../store/zustand-store";

const GetCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const email = localStorage.getItem("admin_mail");
  const affliate_id = localStorage.getItem("affliate_id");
  const user_email = useSelector((state) => state.email);

  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  var currentMonth = currentDate.toLocaleString("default", {
    month: "short",
  });

  const affConversionPlanUpdate = (aff_id, plan) => {
    const user_info = [
      {
        email: plan.email,
        name: plan.name,
        plan: plan.plan_name,
        price: plan.price,
        year: currentYear,
        month: currentMonth,
      },
    ];

    const payload = {
      aff_id,
      data: JSON.stringify(user_info),
    };

    axios
      .get(GET_AFF_CONVERSION(aff_id))
      .then((response) => {
        var user = response?.data?.[0]?.user;
        if (user?.length === 0) {
          axios.put(UPDATE_affiliateGet(payload));
        } else {
          const index = user?.findIndex((entry) => entry.email === user_email);
          if (index !== -1) {
            // user[index] = data;
          } else {
            axios.put(UPDATE_affiliateGet(payload));
          }
        }
      })
      .catch(() => {});
  };

  const getAddOnPlans = async () => {
    try {
      const response = await axios.get(GET_USER_ADDON(email));
      return response.data;
    } catch (error) {
      console.error("GET request failed:", error);
      throw error;
    }
  };

  const handleLimitVlaue = (limit) => {
    if (limit) {
      return Number(limit);
    } else {
      return 0;
    }
  };

  const handleUserLimits = (plan, addon) => {
    const addon_plan = addon?.[0] || [];

    dispatch({
      type: "BACKLINKLIMIT",
      payload: {
        backlinks_rows_limit:
          Number(plan?.backlinks_rows_limit) +
          handleLimitVlaue(addon_plan?.backlinks),
        backlinks_domain_lmt:
          Number(plan?.backlinks_domain_lmt) +
          handleLimitVlaue(addon_plan?.backlink_domain),
      },
    });
    dispatch({
      type: "USERPROJECTLIMIT",
      payload: Number(plan.proj_len) + handleLimitVlaue(addon_plan?.project),
    });
    dispatch({
      type: "USERKEYWORDLIMIT",
      payload:
        Number(plan.keyword_len) + handleLimitVlaue(addon_plan?.track_key),
    });
    dispatch({
      type: "SUBUSERINVITELIMIT",
      payload:
        Number(plan.sub_users_limit) + handleLimitVlaue(addon_plan?.sub_invite),
    });
    dispatch({
      type: "COMPETITORSLIMIT",
      payload:
        Number(plan.competitors_limit) +
        handleLimitVlaue(addon_plan?.competitor),
    });
    dispatch({
      type: "DOMAINVIEWLIMIT",
      payload:
        Number(plan.site_overview_limit) +
        handleLimitVlaue(addon_plan?.dom_over),
    });
    dispatch({
      type: "CRAWLDOMAINLIMIT",
      payload:
        Number(plan.crawl_domain_limit) +
        handleLimitVlaue(addon_plan?.crawl_domain),
    });
    dispatch({
      type: "KEYWORDVIEWLIMIT",
      payload: Number(plan.key_limit) + handleLimitVlaue(addon_plan?.key_res),
    });
    dispatch({ type: "ISPLAN", payload: true });
  };

  const handleCustomPlan = (result) => {
    const plan = {
      backlinks_domain_lmt: 10,
      backlinks_rows_limit: 10000,
      competitors_limit: 5,
      crawl_domain_limit: 10,
      key_limit: 200,
      keyword_len: 1500,
      plan_name: "Custom Plan",
      plan: 2,
      proj_len: 25,
      site_audit_limit: 2000,
      site_overview_limit: 400,
      sub_users_limit: 2,
      referral_user: false,
      ref_domain: 5,
      ai_addon: false,
      user_type: "subscription",
      whitelabel: true,
      price: null,
      ai_writer: false,
      map_tracker: true,
      schedule_report: 300,
      custom_email_limit: 30,
      exact_url: 0,
    };

    ZustandStore.setState({
      customer_plan: plan,
      plan_loaded: true,
    });
    handleUserLimits(plan, result);
  };

  const handleUserSubscription = async (addOnLimits) => {
    const addon_plan = addOnLimits?.[0] || [];
    try {
      const response = await axios.get(
        GET_USER_PLAN_LIMITS(encodeURIComponent(email))
      );
      const plans = response?.data?.[0] || [];
      const exact_url =
        Number(plans?.exact_url) + handleLimitVlaue(addon_plan?.exact_url);

      ZustandStore.setState({
        customer_plan: {
          ...plans,
          exact_url,
          whitelabel: plans?.whitelabel || addon_plan?.pdf || false,
          map_tracker: plans?.map_tracker || addon_plan?.map_track || false,
          referral_user: plans?.user_type === "referral" || false,
          ai_plan: {
            ...plans.ai_plan,
            article: plans.ai_plan.article + handleLimitVlaue(addon_plan?.ai),
            meta: plans.ai_plan.meta + handleLimitVlaue(addon_plan?.meta),
          },
          site_audit_limit:
            plans.site_audit_limit + handleLimitVlaue(addon_plan?.site_audit),
          site_check_limit:
            plans.site_check_limit + handleLimitVlaue(addon_plan?.site_audit),
          ai_keyword:
            plans.ai_keyword + handleLimitVlaue(addon_plan?.ai_track_keyword),
        },
        plan_loaded: true,
      });
      localStorage.setItem("plan_price", plans.price);
      handleUserLimits(plans, addOnLimits);
      if (affliate_id !== "0") {
        affConversionPlanUpdate(affliate_id, plans);
      }
    } catch (error) {
      navigate("/upgrade");
      dispatch({ type: "ISPLAN", payload: false });
      ZustandStore.setState({
        customer_plan: [],
        plan_loaded: true,
      });
    }
  };
  // "tier-1"
  const fetchUserSubscriptions = async () => {
    if (!email) return;
    const result = await getAddOnPlans();
    if (email === "info@hitzdigitalmarketing.com") {
      handleCustomPlan(result);
    } else {
      handleUserSubscription(result);
    }
  };

  useEffect(() => {
    fetchUserSubscriptions();
  }, [email]);

  return null;
};

export default GetCustomer;
